/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
type DevelopmentProductDetails_product$ref = any;
type DevelopmentProductSelectionDialog_development$ref = any;
type MappingImage_image$ref = any;
type MappingImage_products$ref = any;
export type LotDisplayStatus = "available" | "not_set" | "reserved" | "sold";
import type { FragmentReference } from "relay-runtime";
declare export opaque type DevelopmentLots_development$ref: FragmentReference;
declare export opaque type DevelopmentLots_development$fragmentType: DevelopmentLots_development$ref;
export type DevelopmentLots_development = {|
  +id: string,
  +mappingImage: ?{|
    +$fragmentRefs: MappingImage_image$ref
  |},
  +products: $ReadOnlyArray<{|
    +id: string,
    +lotReference: ?string,
    +salePrice: ?number,
    +displayStatus: LotDisplayStatus,
    +hidePriceOnPortals: ?boolean,
    +property: {|
      +floorOfFlat: ?number,
      +numberOfRooms: ?number,
      +numberOfBedrooms: ?number,
      +grossFloorSurface: ?number,
      +balconySurface: ?number,
      +gardenSurface: ?number,
      +terraceSurface: ?number,
      +basementSurface: ?number,
      +weightedFloorSurface: ?number,
      +livingSurface: ?number,
      +usableSurface: ?number,
    |},
    +$fragmentRefs: DevelopmentProductDetails_product$ref & MappingImage_products$ref,
  |}>,
  +$fragmentRefs: DevelopmentProductSelectionDialog_development$ref,
  +$refType: DevelopmentLots_development$ref,
|};
export type DevelopmentLots_development$data = DevelopmentLots_development;
export type DevelopmentLots_development$key = {
  +$data?: DevelopmentLots_development$data,
  +$fragmentRefs: DevelopmentLots_development$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentLots_development",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "mappingImage",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MappingImage_image"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "products",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lotReference",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "salePrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hidePriceOnPortals",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Property",
          "kind": "LinkedField",
          "name": "property",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "floorOfFlat",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "numberOfRooms",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "numberOfBedrooms",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "grossFloorSurface",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "balconySurface",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "gardenSurface",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "terraceSurface",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "basementSurface",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "weightedFloorSurface",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "livingSurface",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "usableSurface",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DevelopmentProductDetails_product"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MappingImage_products"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentProductSelectionDialog_development"
    }
  ],
  "type": "DevelopmentProduct",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '2be00bfaa4728507ac6b64fb970872b9';

export default node;
